export default "__VITE_ASSET__D$OzCum4__"